interface ISiteModelValueChanged {
    initial: boolean;
    path: string[];
    value: any;
    changer: any;
}
interface ISiteModel {

    changedEvent: IQueryEvent<ISiteModelValueChanged>;
    get(path: string[]): any;
    set(path: string[], changer: any, value: any, initial: boolean): boolean;
}

function hasInterface<T>(object: any, interfaceName: string): object is T {
    return '__interface' in object && object.__interface == interfaceName;
}

class SiteModel
    implements ISiteModel {

    private readonly __interface = "ISiteModel";
    private readonly _model: any;
    private readonly _changedEvent: QueryEvent<ISiteModelValueChanged>
        = new QueryEvent<ISiteModelValueChanged>();


    public get changedEvent() { return this._changedEvent.expose(); }

    constructor(model: any) {
        this._model = model;
    }

    static equals(path: string[], path2: string[]) {
        if (path.length !== path2.length) {
            return false;
        }

        for (let i = 0; i < path.length; i++) {
            if (path[i] !== path2[i]) {
                return false;
            }
        }

        return true;
    }

    static split(path?: string) {
        if (!path)
            return [];    

        return path
            .replace(/\[([^\]]*)\]/g, '.$1')
            .split('.');
    }

    static splitPath(model: ISiteModel, path?: string) {
        if (!path)
            return [];

        var pathArray : string[][] = [];
        var currString = "";
        var depth = 0;

        pathArray[0] = [];
        for(let i = 0; i < path.length; i++) {
            const char = path[i];

            if (char === '[') {
                if (currString) { // Edge case ][
                    pathArray[depth].push(currString);
                    currString = "";
                }
                pathArray[++depth] = [];
            } else if (char === ']') {
                if (!isNaN(Number(currString)) && Number.isInteger(Number(currString))) {
                    pathArray[--depth].push(currString);
                    currString = "";
                } else {
                    if (currString) { // Edge case ]]
                        pathArray[depth].push(currString);
                        currString = "";
                    }
                    var currPath = pathArray[depth];
                    var value = model.get(currPath);
                    if (value === undefined)
                        pathArray[--depth].push(currPath.join("."));
                    else
                        pathArray[--depth].push(QueryJSON.toCamelCase(value))
                    
                }
            } else if (char === '.') {
                if (currString) { // Edge case ].
                    pathArray[depth].push(currString);
                    currString = "";
                }
            } else {
                currString += char;
            }
        }
        
        if (currString) {
            pathArray[depth].push(currString);
        }

        return pathArray[0];
    }

    get(path: string[]) {
        let currentValue = this._model;
        for(let pat of path) {
            if (currentValue === undefined)
                return undefined;

            currentValue = currentValue[pat];
        }

        return currentValue;
    }
    set(path: string[], changer: any, value: any, initial: boolean) {
        let currentValue = this._model;

        // We need to copy the path, else pop will destroy the source array!
        let copyPath = path.slice();
        let last = copyPath.pop();

        if(last === undefined)
            return true;

        for (let pat of copyPath) {
            // Make a node of all in between paths,
            // since we haven't travel to last yet
            if (currentValue[pat] === undefined)
                currentValue[pat] = {};
            
            currentValue = currentValue[pat];
        }
        
        // Always set to null when it was undefined
        if (currentValue[last] === undefined)
            currentValue[last] = null;

        let isEqual;
        const oldValue = currentValue[last];
        
        if (oldValue instanceof Date && value instanceof Date) {
            isEqual = oldValue.getTime() === value.getTime();
        } else {
            isEqual = oldValue === value;
        }
        
        if (!isEqual) {
            // Set value
            currentValue[last] = value;
            // Send event
            this._changedEvent.trigger({
                path: path,
                value: value,
                initial: initial,
                changer: changer
            });
            return true;
        }

        return false;
    }
}

class SiteModelInner
    implements ISiteModel {

    private readonly __interface = "ISiteModel";
    private readonly _changedEvent: QueryEvent<ISiteModelValueChanged>
        = new QueryEvent<ISiteModelValueChanged>();

    public get changedEvent() { return this._changedEvent.expose(); }
    private readonly _innerModel: ISiteModel;
    private readonly _path: string[];

    constructor(model: ISiteModel, path: string[]) {
        this._innerModel = model;
        this._path = path;
    }

    get(path: string[]) {
        return this._innerModel.get(
            this._path.concat(path)
        );
    }
    set(path: string[], changer: any, value: any, initial: boolean) {
        var changed = this._innerModel.set(
            this._path.concat(path),
            changer,
            value,
            initial
        );
        
        if (changed) {
            this._changedEvent.trigger({
                changer: changer,
                path: path,
                value: value,
                initial: initial
            });
        }

        return changed;
    }
}